module.exports = __webpack_public_path__ + "img/c03_unitaugur_Normal_ua.c8ac339f.webp";